export default {
  exposeMock: () => {

    //general function
    window.sendMockMsg = (mockMsg) => {
      window.processMsg(JSON.stringify(mockMsg));
    };

    // new event in new sport (add and remove)
    const mockEventCaca = {
      'event': {
        'id': 1005268123,
        'name': 'Neman Grodno - BFC Daugavpils',
        'englishName': 'Neman Grodno - BFC Daugavpils',
        'homeName': 'Neman Grodno',
        'awayName': 'BFC Daugavpils',
        'start': '2019-01-31T10:32:24.518Z',
        'group': 'Club Friendly Matches',
        'groupId': 1000093393,
        'path': [{ 'id': 1000093190, 'name': 'Football', 'englishName': 'Football', 'termKey': 'football' }, {
          'id': 1000093393,
          'name': 'Club Friendly Matches',
          'englishName': 'Club Friendly Matches',
          'termKey': 'club_friendly_matches'
        }],
        'nonLiveBoCount': 7,
        'liveBoCount': 15,
        'sport': 'CACA',
        'tags': ['VISUALIZATION', 'OPEN_FOR_LIVE', 'MATCH'],
        'state': 'STARTED',
        'teamColors': {
          'home': { 'shirtColor1': '#00cc00', 'shirtColor2': '#00cc00' },
          'away': { 'shirtColor1': '#0000ff', 'shirtColor2': '#0000ff' }
        }
      },
      'liveData': {
        'eventId': 1005268123,
        'matchClock': {
          'minute': 64,
          'second': 26,
          'minutesLeftInPeriod': 25,
          'secondsLeftInMinute': 34,
          'period': '2nd half',
          'running': true
        },
        'score': { 'home': '1', 'away': '0', 'who': 'UNKNOWN' },
        'statistics': {
          'football': {
            'home': { 'yellowCards': 2, 'redCards': 1, 'corners': 3 },
            'away': { 'yellowCards': 1, 'redCards': 0, 'corners': 1 }
          }
        },
        'latestVisualization': {
          'id': 686,
          'eventId': 1005268123,
          'occurrenceTypeId': 'DANGEROUS_ATTACK_HOME',
          'periodId': 'SECOND_HALF',
          'visualization': { 'position': { 'zone': 'DANGEROUS_ATTACK_HOME' } }
        },
        'liveStatistics': [
          { 'occurrenceTypeId': 'CORNERS_HOME', 'count': 3 }, {
            'occurrenceTypeId': 'CARDS_YELLOW_AWAY',
            'count': 1
          }, { 'occurrenceTypeId': 'GOALS_HOME', 'count': 1 }, {
            'occurrenceTypeId': 'SHOTS_ON_TARGET_HOME',
            'count': 5
          }, { 'occurrenceTypeId': 'SHOTS_OFF_TARGET_HOME', 'count': 6 }, {
            'occurrenceTypeId': 'CARDS_YELLOW_HOME',
            'count': 2
          }, { 'occurrenceTypeId': 'CARDS_RED_HOME', 'count': 1 }, {
            'occurrenceTypeId': 'CORNERS_AWAY',
            'count': 1
          }, { 'occurrenceTypeId': 'SHOTS_OFF_TARGET_AWAY', 'count': 5 }, {
            'occurrenceTypeId': 'SHOTS_ON_TARGET_AWAY',
            'count': 2
          }, { 'occurrenceTypeId': 'ATTACK_AWAY', 'count': 55 }, {
            'occurrenceTypeId': 'DANGEROUS_ATTACK_AWAY',
            'count': 32
          }, { 'occurrenceTypeId': 'ATTACK_HOME', 'count': 68 }, { 'occurrenceTypeId': 'DANGEROUS_ATTACK_HOME', 'count': 37 }]
      },
      'mainBetOffer': {
        'id': 2153652259,
        'criterion': { 'id': 1001159858, 'label': 'Full Time', 'englishLabel': 'Full Time' },
        'betOfferType': { 'id': 2, 'name': 'Match', 'englishName': 'Match' },
        'eventId': 1005268123,
        'outcomes': [{
          'id': 2544351075,
          'label': '1',
          'englishLabel': '1',
          'odds': 1090,
          'participant': 'Neman Grodno',
          'type': 'OT_ONE',
          'betOfferId': 2153652259,
          'changedDate': '2019-01-31T11:54:05Z',
          'participantId': 1000072455,
          'oddsFractional': '1/12',
          'oddsAmerican': '-1115',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }, {
          'id': 2544351076,
          'label': 'X',
          'englishLabel': 'X',
          'odds': 8000,
          'type': 'OT_CROSS',
          'betOfferId': 2153652259,
          'changedDate': '2019-01-31T11:54:05Z',
          'oddsFractional': '7/1',
          'oddsAmerican': '700',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }, {
          'id': 2544351077,
          'label': '2',
          'englishLabel': '2',
          'odds': 34000,
          'participant': 'BFC Daugavpils',
          'type': 'OT_TWO',
          'betOfferId': 2153652259,
          'changedDate': '2019-01-31T11:54:05Z',
          'participantId': 1001262000,
          'oddsFractional': '33/1',
          'oddsAmerican': '3300',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }],
        'tags': ['OFFERED_PREMATCH', 'OFFERED_LIVE', 'PBA_DISABLED', 'MAIN'],
        'oddsStats': {
          'unexpectedOddsTrend': false,
          'outcomeId': 2544351075,
          'startingOdds': 1090,
          'startingOddsFractional': '1/12',
          'startingOddsAmerican': '-1115'
        },
        'cashOutStatus': 'ENABLED'
      }
    };
    const mockGroupCaca = {
      'id': 9999,
      'name': 'Caca',
      'englishName': 'Caca',
      'sport': 'CACA',
      'termKey': 'caca',
      'sortOrder': '2'
    };
    const mockLEOCaca = [{
      't': '111',
      'mt': 5,
      'leo': {
        'liveEvent': mockEventCaca,
        'group': { groups: [mockGroupCaca] }
      }
    }];
    const mockERCaca = [{
      't': '222',
      'mt': 18,
      'er': {
        'eventId': 1005268123
      }
    }];
    window.sendLiveEventOpenedInNewSport = () => {
      window.processMsg(JSON.stringify(mockLEOCaca));
    };
    window.sendEventRemovedLastInSport = () => {
      window.processMsg(JSON.stringify(mockERCaca));
    };


    // tennis event - add/remove event + change stats and score
    const mockEventTennis = {
      'event': {
        'id': 1005271480,
        'name': 'Niculescu, Monica - Linette, Magda',
        'englishName': 'Niculescu, Monica - Linette, Magda',
        'homeName': 'Niculescu, Monica',
        'awayName': 'Linette, Magda',
        'start': '2019-01-31T11:03:30.119Z',
        'group': 'Hua Hin',
        'groupId': 2000090910,
        'path': [{ 'id': 1000093193, 'name': 'Tennis', 'englishName': 'Tennis', 'termKey': 'tennis' }, {
          'id': 1000093904,
          'name': 'WTA',
          'englishName': 'WTA',
          'termKey': 'wta'
        }, { 'id': 2000090910, 'name': 'Hua Hin', 'englishName': 'Hua Hin', 'termKey': 'hua_hin' }],
        'nonLiveBoCount': 9,
        'liveBoCount': 48,
        'sport': 'TENNIS',
        'tags': ['VISUALIZATION', 'OPEN_FOR_LIVE', 'PREMATCH_STATS', 'MATCH'],
        'state': 'STARTED'
      },
      'liveData': {
        'eventId': 1005271480,
        'matchClock': { 'minute': 46, 'second': 58, 'running': true },
        'score': { 'home': '40', 'away': '0', 'who': 'HOME' },
        'statistics': { 'sets': { 'home': [6, 4, -1], 'away': [4, 4, -1], 'homeServe': true } },
        'liveStatistics': [{ 'occurrenceTypeId': 'DOUBLE_FAULTS_AWAY', 'count': 2 }, {
          'occurrenceTypeId': 'DOUBLE_FAULTS_HOME',
          'count': 1
        }, { 'occurrenceTypeId': 'ACES_WON_AWAY', 'count': 1 }, {
          'occurrenceTypeId': 'BREAK_POINT_CONVERSION_AWAY',
          'count': 100
        }, { 'occurrenceTypeId': 'BREAK_POINT_CONVERSION_HOME', 'count': 67 }, {
          'occurrenceTypeId': 'FIRST_SERVE_WINNING_AWAY',
          'count': 56
        }, { 'occurrenceTypeId': 'FIRST_SERVE_WINNING_HOME', 'count': 82 }]
      },
      'mainBetOffer': {
        'id': 2153378421,
        'criterion': { 'id': 1001159551, 'label': 'Match Odds', 'englishLabel': 'Match Odds' },
        'betOfferType': { 'id': 2, 'name': 'Match', 'englishName': 'Match' },
        'eventId': 1005271480,
        'outcomes': [{
          'id': 2543433942,
          'label': '1',
          'englishLabel': '1',
          'odds': 1180,
          'type': 'OT_ONE',
          'betOfferId': 2153378421,
          'changedDate': '2019-01-31T11:55:17Z',
          'oddsFractional': '1/6',
          'oddsAmerican': '-560',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }, {
          'id': 2543433944,
          'label': '2',
          'englishLabel': '2',
          'odds': 4700,
          'type': 'OT_TWO',
          'betOfferId': 2153378421,
          'changedDate': '2019-01-31T11:55:17Z',
          'oddsFractional': '18/5',
          'oddsAmerican': '370',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }],
        'tags': ['OFFERED_PREMATCH', 'OFFERED_LIVE', 'PBA_DISABLED', 'MAIN'],
        'cashOutStatus': 'ENABLED'
      }
    };
    const mockGroupTennis = {
      'id': 1000093193,
      'name': 'Tennis',
      'englishName': 'Tennis',
      'sortOrder': '2',
      'sport': 'TENNIS',
      'termKey': 'tennis'
    };
    const mockLEOTennis = [{
      't': '333',
      'mt': 5,
      'leo': {
        'liveEvent': mockEventTennis,
        'group': { groups: [mockGroupTennis] }
      }
    }];
    const mockERTennis = [{
      't': '444',
      'mt': 18,
      'er': {
        'eventId': 1005271480
      }
    }];
    const mockScoreAndStatsTennis = [
      {
        't': '555',
        'mt': 16,
        'score': {
          'eventId': 1005271480,
          'score': { 'home': '0', 'away': '0', 'who': 'HOME' }
        }
      }, {
        't': '666',
        'mt': 17,
        'stats': {
          'eventId': 1005271480,
          'statistics': { 'sets': { 'home': [6, 5, -1], 'away': [4, 4, -1], 'homeServe': true } }
        }
      }];
    window.sendLiveEventOpenedInTennis = () => {
      window.processMsg(JSON.stringify(mockLEOTennis));
    };
    window.sendEventRemovedTennis = () => {
      window.processMsg(JSON.stringify(mockERTennis));
    };
    window.sendScoreAndStatsUpdateTennis = () => {
      window.processMsg(JSON.stringify(mockScoreAndStatsTennis));
    };

    // add basket event + match clock update and remove
    const mockEventBasket = {
      'event': {
        'id': 1005214630,
        'name': 'Busan KT Sonicboom - Anyang KGC',
        'englishName': 'Busan KT Sonicboom - Anyang KGC',
        'homeName': 'Busan KT Sonicboom',
        'awayName': 'Anyang KGC',
        'start': '2019-01-31T10:30:00Z',
        'group': 'KBL',
        'groupId': 2000050629,
        'path': [{ 'id': 1000093204, 'name': 'Basketball', 'englishName': 'Basketball', 'termKey': 'basketball' }, {
          'id': 2000050628,
          'name': 'South Korea',
          'englishName': 'South Korea',
          'termKey': 'south_korea'
        }, { 'id': 2000050629, 'name': 'KBL', 'englishName': 'KBL', 'termKey': 'kbl' }],
        'nonLiveBoCount': 22,
        'liveBoCount': 22,
        'sport': 'BASKETBALL',
        'tags': ['OPEN_FOR_LIVE', 'PREMATCH_STATS', 'MATCH'],
        'state': 'STARTED'
      },
      'liveData': {
        'eventId': 1005214630,
        'matchClock': {
          'minute': 30,
          'second': 42,
          'minutesLeftInPeriod': 9,
          'secondsLeftInMinute': 18,
          'period': '4th Quarter',
          'running': true
        },
        'score': { 'home': '60', 'away': '64', 'info': 'Q1: 10-22 | Q2: 27-13 | Q3: 23-26 | Q4: 0-3', 'who': 'UNKNOWN' },
        'liveStatistics': [{ 'occurrenceTypeId': 'POINTS_HOME', 'count': 60 }, { 'occurrenceTypeId': 'POINTS_AWAY', 'count': 64 }]
      },
      'mainBetOffer': {
        'id': 2153642531,
        'criterion': { 'id': 1001159732, 'label': 'Including Overtime', 'englishLabel': 'Including Overtime' },
        'betOfferType': { 'id': 2, 'name': 'Match', 'englishName': 'Match' },
        'eventId': 1005214630,
        'outcomes': [{
          'id': 2544323741,
          'label': 'Busan KT Sonicboom',
          'englishLabel': 'Busan KT Sonicboom',
          'odds': 2550,
          'participant': 'Busan KT Sonicboom',
          'type': 'OT_ONE',
          'betOfferId': 2153642531,
          'changedDate': '2019-01-31T11:55:20Z',
          'participantId': 1000538650,
          'oddsFractional': '31/20',
          'oddsAmerican': '155',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }, {
          'id': 2544323742,
          'label': 'Anyang KGC',
          'englishLabel': 'Anyang KGC',
          'odds': 1480,
          'participant': 'Anyang KGC',
          'type': 'OT_TWO',
          'betOfferId': 2153642531,
          'changedDate': '2019-01-31T11:55:20Z',
          'participantId': 1000538648,
          'oddsFractional': '12/25',
          'oddsAmerican': '-210',
          'status': 'OPEN',
          'cashOutStatus': 'ENABLED'
        }],
        'tags': ['OFFERED_PREMATCH', 'OFFERED_LIVE', 'PBA_DISABLED', 'MAIN'],
        'cashOutStatus': 'ENABLED'
      }
    };
    const mockGroupBasket = {
      'id': 1000093204,
      'name': 'Basketball',
      'englishName': 'Basketball',
      'sortOrder': '3',
      'sport': 'BASKETBALL',
      'termKey': 'basketball'
    };
    const mockLEOBasket = [{
      't': '999',
      'mt': 5,
      'leo': {
        'liveEvent': mockEventBasket,
        'group': { groups: [mockGroupBasket] }
      }
    }];
    const mockMatchUpdateStopRunning4020Basket = [{
      't': '777',
      'mt': 15,
      'mcu': {
        'eventId': 1005214630,
        'matchClock': {
          'minute': 40,
          'second': 20,
          'running': false
        }
      }
    }];
    const mockMatchUpdateStartRunning4020Basket = [{
      't': '888',
      'mt': 15,
      'mcu': {
        'eventId': 1005214630,
        'matchClock': {
          'minute': 40,
          'second': 20,
          'running': true
        }
      }
    }];
    window.sendLiveEventOpenedInBasket = () => {
      window.processMsg(JSON.stringify(mockLEOBasket));
    };
    window.sendMatchUpdateStopRunningBasket = () => {
      window.processMsg(JSON.stringify(mockMatchUpdateStopRunning4020Basket));
    };
    window.sendMatchUpdateStartRunningBasket = () => {
      window.processMsg(JSON.stringify(mockMatchUpdateStartRunning4020Basket));
    };


    // bet offers updates
    const volleyEvent = {
      'event': {
        'id': 1005269801,
        'name': 'Eryaman Genclik U18 (W) - Tarim Spor U18 (W)',
        'englishName': 'Eryaman Genclik U18 (W) - Tarim Spor U18 (W)',
        'homeName': 'Eryaman Genclik U18 (W)',
        'awayName': 'Tarim Spor U18 (W)',
        'start': '2019-01-31T11:41:01.845Z',
        'group': 'U18 League (W)',
        'groupId': 2000056596,
        'path': [{ 'id': 1000093214, 'name': 'Volleyball', 'englishName': 'Volleyball', 'termKey': 'volleyball' }, {
          'id': 2000052308,
          'name': 'Turkey',
          'englishName': 'Turkey',
          'termKey': 'turkey'
        }, { 'id': 2000056596, 'name': 'U18 League (W)', 'englishName': 'U18 League (W)', 'termKey': 'u18_league__w_' }],
        'nonLiveBoCount': 0,
        'liveBoCount': 15,
        'sport': 'VOLLEYBALL',
        'tags': ['OPEN_FOR_LIVE', 'MATCH'],
        'state': 'STARTED'
      },
      'liveData': {
        'eventId': 1005269801,
        'matchClock': { 'minute': 14, 'second': 31, 'running': true },
        'score': { 'home': '10', 'away': '15', 'who': 'AWAY' },
        'statistics': { 'sets': { 'home': [-1, -1, -1, -1, -1], 'away': [-1, -1, -1, -1, -1], 'homeServe': false } },
        'liveStatistics': []
      },
      'mainBetOffer': null
    };
    const volleyGroup = {
      'id': 1000093214,
      'name': 'Volleyball',
      'englishName': 'Volleyball',
      'sport': 'VOLLEYBALL',
      'termKey': 'volleyball'
    };
    const volleyMainBO = {
      'id': 2153682897,
      'criterion': { 'id': 1001160042, 'label': 'Match Odds', 'englishLabel': 'Match Odds' },
      'betOfferType': { 'id': 2, 'name': 'Match', 'englishName': 'Match' },
      'eventId': 1005269801,
      'outcomes': null,
      'tags': ['OFFERED_LIVE', 'PBA_DISABLED', 'MAIN'],
      'cashOutStatus': 'ENABLED'
    };
    const volleyOutcomes = [
      {
        'id': 2544475458,
        'label': 'Eryaman Genclik U18 (W)',
        'englishLabel': 'Eryaman Genclik U18 (W)',
        'odds': 7000,
        'participant': 'Eryaman Genclik U18 (W)',
        'type': 'OT_ONE',
        'betOfferId': 2153682897,
        'changedDate': '2019-01-31T11:54:51Z',
        'participantId': 1004687650,
        'oddsFractional': '6/1',
        'oddsAmerican': '600',
        'status': 'OPEN',
        'cashOutStatus': 'ENABLED'
      }, {
        'id': 2544475459,
        'label': 'Tarim Spor U18 (W)',
        'englishLabel': 'Tarim Spor U18 (W)',
        'odds': 1090,
        'participant': 'Tarim Spor U18 (W)',
        'type': 'OT_TWO',
        'betOfferId': 2153682897,
        'changedDate': '2019-01-31T11:54:51Z',
        'participantId': 1005058742,
        'oddsFractional': '1/12',
        'oddsAmerican': '-1115',
        'status': 'OPEN',
        'cashOutStatus': 'ENABLED'
      },
      {
        'id': 2544475460,
        'label': 'Luciana U18 (W)',
        'englishLabel': 'Luciana U18 (W)',
        'odds': 5555,
        'participant': 'Luciana U18 (W)',
        'type': 'OT_TWO',
        'betOfferId': 2153682897,
        'changedDate': '2019-01-31T11:54:51Z',
        'participantId': 1005058742,
        'oddsFractional': '1/12',
        'oddsAmerican': '-1115',
        'status': 'OPEN',
        'cashOutStatus': 'ENABLED'
      }
      ];

    const mockLEOVolley = [{
      't': '112',
      'mt': 5,
      'leo': {
        'liveEvent': volleyEvent,
        'group': { groups: [volleyGroup] }
      }
    }];
    const mockBOAVolley = [{
      't': '113',
      'mt': 6,
      'boa': {
        'betOffer': volleyMainBO
      }
    }];
    const mockBOOAVolley = [{
      't': '114',
      'mt': 22,
      'booa': {
        'eventId': 1005269801,
        'outcomes': volleyOutcomes
      }
    }];
    const mockBOOUVolley = [{
      't': '115',
      'mt': 11,
      'boou': {
        'eventId': 1005269801,
        'outcomes': [
          {
            'id': 2544475458,
            'odds': 9500,
            'betOfferId': 2153682897,
            'oddsFractional': '17/2',
            'oddsAmerican': '850'
          }
        ]
      }
    }];
    const mockBOORVolley = [{
      't': '116',
      'mt': 23,
      'boor': {
        'eventId': 1005269801,
        'outcomes': [{
          'id': 2544475459, 'betOfferId': 2153682897
        }]
      }
    }];
    const mockBOSUVolley = [{
      't': '117',
      'mt': 8,
      'bosu': {
        'betOfferId': 2153682897,
        'eventId': 1005269801,
        'suspended': true,
        'cashOutStatus': 'ENABLED'
      }
    }];
    const mockBORVolley = [{
      't': '118',
      'mt': 7,
      'bor': {
        'betOfferId': 2153682897
      }
    }];

    window.sendVolleyEventWithoutMainBO = () => {
      window.processMsg(JSON.stringify(mockLEOVolley));
    };
    window.sendAddMainBetOfferWithoutOutcomesForVolleyEvent = () => {
      window.processMsg(JSON.stringify(mockBOAVolley));
    };
    window.sendAddOutcomesForVolleyEvent = () => {
      window.processMsg(JSON.stringify(mockBOOAVolley));
    };
    window.sendOutcomeUpdateForVolleyEvent = () => {
      window.processMsg(JSON.stringify(mockBOOUVolley));
    };
    window.sendOutcomeRemovedForVolleyEvent = () => {
      window.processMsg(JSON.stringify(mockBOORVolley));
    };
    window.sendBetOfferSuspendedForVolleyEvent = () => {
      window.processMsg(JSON.stringify(mockBOSUVolley));
    };
    window.sendBetOfferRemovedFroVolleyEvent = () => {
      window.processMsg(JSON.stringify(mockBORVolley));
    };
  }

};

